// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"8595ca64727b0a7e2ee0","655":"199f72aadc4e7af53325"}[chunkId] + ".js";
};